import React from 'react';
import { Redirect } from 'react-router-dom';

export const RedirectToNewApiRoute = () => <Redirect to="/tools/api" />;

export default RedirectToNewApiRoute;